import comp from "./OauthPopup";
export default comp;
